// extracted by mini-css-extract-plugin
export default {"carousel":"ioGhQLMYZW7kys_vEIww","item-navigation":"pvxR0ZoM6pKkWQS_9QPd","item":"TbIyTAtIVe5Y4IUl3xBF","item-active":"ZWv1UYMPXIrMBz3YnBjK"};